import { render, staticRenderFns } from "./AsignarAutorUsuarioWeb.vue?vue&type=template&id=2616a4a0"
import script from "./AsignarAutorUsuarioWeb.vue?vue&type=script&lang=ts"
export * from "./AsignarAutorUsuarioWeb.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports